// extracted by mini-css-extract-plugin
export default {"container":"Tuto_container__ocmbt"};